// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LongWriteResultCreate
 */
export interface LongWriteResultCreate {
  /**
   *
   * @type {string}
   * @memberof LongWriteResultCreate
   */
  assignmentId?: string | null
  /**
   *
   * @type {number}
   * @memberof LongWriteResultCreate
   */
  assignmentTaskId?: number | null
  /**
   *
   * @type {string}
   * @memberof LongWriteResultCreate
   */
  questId?: string | null
  /**
   *
   * @type {number}
   * @memberof LongWriteResultCreate
   */
  userTargetWordCount?: number | null
  /**
   *
   * @type {string}
   * @memberof LongWriteResultCreate
   */
  userTitle?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteResultCreate
   */
  eventId?: string | null
}

/**
 * Check if a given object implements the LongWriteResultCreate interface.
 */
export function instanceOfLongWriteResultCreate(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LongWriteResultCreateFromJSON(
  json: any,
): LongWriteResultCreate {
  return LongWriteResultCreateFromJSONTyped(json, false)
}

export function LongWriteResultCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LongWriteResultCreate {
  if (json === undefined || json === null) {
    return json
  }
  return {
    assignmentId: !exists(json, 'assignmentId')
      ? undefined
      : json['assignmentId'],
    assignmentTaskId: !exists(json, 'assignmentTaskId')
      ? undefined
      : json['assignmentTaskId'],
    questId: !exists(json, 'questId') ? undefined : json['questId'],
    userTargetWordCount: !exists(json, 'userTargetWordCount')
      ? undefined
      : json['userTargetWordCount'],
    userTitle: !exists(json, 'userTitle') ? undefined : json['userTitle'],
    eventId: !exists(json, 'eventId') ? undefined : json['eventId'],
  }
}

export function LongWriteResultCreateToJSON(
  value?: LongWriteResultCreate | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    assignmentId: value.assignmentId,
    assignmentTaskId: value.assignmentTaskId,
    questId: value.questId,
    userTargetWordCount: value.userTargetWordCount,
    userTitle: value.userTitle,
    eventId: value.eventId,
  }
}
